import { IScheduledCustomReport } from '@/Interfaces/ReportBuilder/ScheduledCustomReport.interface';
import { useCallback, useMemo, useState } from 'react';

export const useScheduledReportEditing = () => {
  const [editingReport, setEditingReport] = useState<IScheduledCustomReport | null>(null);

  const open = useCallback((report: IScheduledCustomReport) => setEditingReport(report), []);
  const close = useCallback(() => setEditingReport(null), []);

  return useMemo(() => ({ editingReport, open, close }), [editingReport, open, close]);
};
